import React, { useEffect, useState } from "react";
import HeaderPrint from "../../../Pdf/PrintHeaderAccount";
import axios from "axios";
import config from "../../../config";
import pdfStyles from "../../../Pdf/pdfStyles";
import PrintFooter from "../../../Pdf/PrintFooter";
import { PrintFormateNumber } from "../../../Pdf/PrintFormateNumber";
import {
  PDFViewer,
  Page,
  Text,
  View,
  Document,
} from "@react-pdf/renderer";
import { Spin } from "antd";
import moment from "moment";

const PrintWorkingCapital = () => {
  const UserID = localStorage.getItem("ID");
  const AccessKey = localStorage.getItem("AccessKey");

  const urlParams = new URLSearchParams(window.location.search);
  const StartDate = urlParams.get("date") || moment().format("YYYY-MM-DD");

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = "Print Working Capital";
    setLoading(true);

    const payload = {
      UserId: UserID,
      AccessKey: AccessKey,
      Dated: StartDate,
    };

    const api_config = {
      method: "post",
      url: config.base_url + "Report/GetWorkingCapitalReport",
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    };

    axios(api_config)
      .then((response) => {
        if (response.data.status_code === 1) {
          setData(response.data);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("API Error:", error);
        setLoading(false);
      });
  }, []);

  const {
    totalReceiveable = 0,
    totalStockValue = 0,
    totalCashAtBank = 0,
    totalCashInHand = 0,
    totalPayable = 0,
  } = data;

  const totalInvestment = totalReceiveable + totalStockValue + totalCashAtBank + totalCashInHand;
  const netInvestment = totalInvestment - totalPayable;

  const generateRows = () => {
    const rows = [
      {
        label: "Cash Receivable",
        value: totalReceiveable,
        note: "Taken from Cash receivable report",
      },
      {
        label: "Stock in Hand",
        value: totalStockValue,
        note: "Taken from Stock detail",
      },
      {
        label: "Bank Balance",
        value: totalCashAtBank,
        note: "Taken from cash at bank in Dashboard",
      },
      {
        label: "Cash in Hand",
        value: totalCashInHand,
        note: "Taken from cash at Hand in Dashboard",
      },
      {
        label: "Total Investment",
        value: totalInvestment,
         bold: true,
      },
      {
        label: "Cash Payable",
        value: totalPayable,
        note: "Taken from Cash payable report",
      },
      {
        label: "Net Investment",
        value: netInvestment,
        bold: true,
      },
    ];

    return rows.map((item, index) => (
      <View key={index} style={pdfStyles.row}>
        <View style={[pdfStyles.td, { width: 360 }]}>
          <Text style={[pdfStyles.tdValue, item.bold && { fontWeight: "bold" }]}>
            {item.label}
          </Text>
          {item.note && (
            <Text style={{ fontSize: 9, color: "#f00" }}>{item.note}</Text>
          )}
        </View>
        <View style={[pdfStyles.td, { width: 210, textAlign: "right" }]}>
          <Text
            style={[
              pdfStyles.tdValue,
              item.bold && {
                fontWeight: "bold",
                color: netInvestment < 0 ? "#f00" : "#28a745",
              },
            ]}
          >
            {PrintFormateNumber(item.value, 0)}
          </Text>
        </View>
      </View>
    ));
  };

  const MyDocument = () => (
    <Document>
      <Page size="A4" style={pdfStyles.page}>
        <HeaderPrint />
        <View style={pdfStyles.section}>
          <View style={pdfStyles.title}>
            <Text style={pdfStyles.pagetitle}>Working Capital</Text>
            <Text style={{ fontSize: 10, marginTop: 4 }}>
              Report Date: {moment(StartDate).format(config.date_format)}
            </Text>
          </View>

          <View style={pdfStyles.table}>{generateRows()}</View>

          <View style={{ marginBottom: 60, marginTop: 0 }} fixed>
            <Text
              style={{ fontSize: "8pt" }}
              render={({ pageNumber, totalPages }) =>
                `Page ${pageNumber} / ${totalPages}`
              }
            />
          </View>
        </View>
        <PrintFooter fixed />
      </Page>
    </Document>
  );

  return (
    <div style={{ width: "100%", height: "100vh", overflow: "hidden" }}>
      {loading ? (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin />
        </div>
      ) : (
        <PDFViewer width="100%" height="100%">
          <MyDocument />
        </PDFViewer>
      )}
    </div>
  );
};

export default PrintWorkingCapital;
